import { useFormContext } from 'react-hook-form-mui';
import TestMultiplySelect from 'view/pages/profile/TestPage/MultiplySelect';
import JobLocationAutocomplete from 'view/pages/profile/components/JobLocationAutocomplete';
import * as WPS from 'view/pages/profile/WorkPreferences/styled';
import * as PSCS from 'view/pages/profile/ProfileSettings/styled';
import { Button, RadioGroup } from 'view/components';
import SalaryRange from 'view/components/SalaryRange';
import { JobPostsDropdownAutocomplete } from 'view/pages/candidates/components';
import { useEffect, useState } from 'react';
import { useGetJobPostInfoById } from 'view/pages/candidates/hooks/useGetJobPostInfoById';
import { useNavigate } from 'react-router';
import * as S from './styled';

export const yearsOfExperienceOptions = [
  {
    value: 'Less than 1 year',
    label: 'Less than 1 year',
    yearsOfExperienceMin: 0,
    yearsOfExperienceMax: 1,
  },
  {
    value: '1-2 years',
    label: '1-2 years',
    yearsOfExperienceMin: 1,
    yearsOfExperienceMax: 2,
  },
  { value: '3-5 years', label: '3-5 years', yearsOfExperienceMin: 3, yearsOfExperienceMax: 5 },
  { value: '6-10 years', label: '6-10 years', yearsOfExperienceMin: 6, yearsOfExperienceMax: 10 },
  {
    value: 'More than 10 years',
    label: 'More than 10 years',
    yearsOfExperienceMin: 10,
    yearsOfExperienceMax: 100,
  },
];

const FiltersBlockFields = ({
  positionTypeData,
  isPositionTypeDataLoading,
  /* jobTitleData,
  isJobTitleDataLoading, */
  educationData,
  isEducationDataLoading,
  hardSkillsData,
  isHardSkillsLoading,
  languageData,
  isLanguageDataLoading,
  jobPostData,
  setPage,
}) => {
  const { watch, setValue, control } = useFormContext<any>();

  const jobLocationValue = watch('jobLocation') ?? null;
  const salaryRange = watch('salaryRange') || { from: '', to: '' };

  useEffect(() => {
    if (!jobPostData) return;
    /* setValue('jobTitle', jobPostData?.jobTitle); */
    setValue('query', jobPostData?.jobTitle);
    setValue('positionType', jobPostData?.positionType);
    setValue('jobLocation', jobPostData?.location); // TODO Need to remove
    setValue('onSite', jobPostData?.jobLocation?.onSite);
    setValue('remote', jobPostData?.jobLocation?.remote);
    setValue('hybrid', jobPostData?.jobLocation?.hybrid);
    if (jobPostData?.experienceYearsMin && jobPostData?.experienceYearsMax) {
      const selectedItem: any = yearsOfExperienceOptions.filter((item) => {
        return (
          jobPostData?.experienceYearsMin === item.yearsOfExperienceMin &&
          jobPostData?.experienceYearsMax === item.yearsOfExperienceMax
        );
      });

      if (selectedItem?.length > 0) {
        setValue('yearsOfExperience', selectedItem?.[0]?.value);
      }
    }
    setValue('education', jobPostData?.education ? [jobPostData?.education] : []);
    setValue(
      'hardSkills',
      jobPostData?.skills.filter((skill) => {
        return skill.skill.group === 'Hard Skills';
      })
    );
    setValue('languages', jobPostData?.languages);
    setValue('salaryRange', { from: jobPostData?.salaryMin, to: jobPostData?.salaryMax });
  }, [jobPostData]);

  return (
    <>
      <TestMultiplySelect
        name="positionType"
        label="Position Type *"
        options={positionTypeData || []}
        control={control}
        disabled={isPositionTypeDataLoading || !positionTypeData}
      />
      <JobLocationAutocomplete
        setValue={setValue}
        jobLocationValue={jobLocationValue}
        marginbottom={16}
      />
      <div>
        <WPS.TextTitle style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600' }}>
          Location Type
        </WPS.TextTitle>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginBottom: '16px' }}>
          <PSCS.CheckboxWithText>
            <PSCS.CustomCheckbox
              name="showPhone"
              checked={watch('onSite')}
              onChange={(e) => {
                return setValue('onSite', e.target.checked);
              }}
              disabled={false}
            />
            <p
              style={{
                color: '#444444',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '21.76px',
              }}
            >
              On-site
            </p>
          </PSCS.CheckboxWithText>
          <PSCS.CheckboxWithText>
            <PSCS.CustomCheckbox
              name="remote"
              checked={watch('remote')}
              onChange={(e) => {
                return setValue('remote', e.target.checked);
              }}
              disabled={false}
            />
            <p
              style={{
                color: '#444444',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '21.76px',
              }}
            >
              Remote
            </p>
          </PSCS.CheckboxWithText>
          <PSCS.CheckboxWithText>
            <PSCS.CustomCheckbox
              name="hybrid"
              checked={watch('hybrid')}
              onChange={(e) => {
                return setValue('hybrid', e.target.checked);
              }}
              disabled={false}
            />
            <p
              style={{
                color: '#444444',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '21.76px',
              }}
            >
              Hybrid
            </p>
          </PSCS.CheckboxWithText>
        </div>
      </div>
      <RadioGroup
        name="yearsOfExperience"
        label="Years of Experience"
        options={yearsOfExperienceOptions}
        style={{ marginBottom: '8px' }}
        styleLabel={{ margin: '0' }}
      />
      <TestMultiplySelect
        name="education"
        label="Education Level"
        options={educationData || []}
        control={control}
        disabled={isEducationDataLoading || !educationData}
      />
      <SalaryRange
        fromValue={salaryRange.from}
        toValue={salaryRange.to}
        onChange={(field, value) => {
          setValue('salaryRange', { ...salaryRange, [field]: value });
        }}
      />
      <TestMultiplySelect
        name="hardSkills"
        label="Technical Skills"
        options={hardSkillsData || []}
        control={control}
        disabled={isHardSkillsLoading || !hardSkillsData}
      />
      <TestMultiplySelect
        name="languages"
        label="Languages Required"
        options={languageData || []}
        control={control}
        disabled={isLanguageDataLoading || !languageData}
      />
      <Button
        variant="contained"
        type="submit"
        onClick={() => {
          return setPage(1);
        }}
        text="Apply filters"
        style={{ margin: '24px 0' }}
      />
    </>
  );
};

const FiltersBlock = ({
  onSubmit,
  setPage,
  positionTypeData,
  isPositionTypeDataLoading,
  educationData,
  isEducationDataLoading,
  hardSkillsData,
  isHardSkillsLoading,
  languageData,
  isLanguageDataLoading,
}) => {
  const navigate = useNavigate();
  const { getJobPostInfoById, isLoading, data } = useGetJobPostInfoById();

  const [jobPostsValue, setJobPostsValue] = useState(null);

  const { watch, setValue, handleSubmit } = useFormContext<any>();
  const formValues = watch(); // Следит за изменениями всех полей

  // Функция для подсчёта выбранных фильтров
  const countSelectedFilters = () => {
    let count = 0;

    /* if (formValues.jobTitle) count++; // Должность */
    if (formValues.positionType?.length) count++; // Тип занятости (массив)
    if (formValues.jobLocation) count++; // Локация
    if (formValues.onSite || formValues.remote || formValues.hybrid) count++; // Режим работы
    if (formValues.yearsOfExperience?.trim()) count++; // Опыт работы
    if (formValues.education?.length) count++; // Образование (массив)
    if (formValues.salaryRange?.from > 0 || formValues.salaryRange?.to > 0) count++; // Зарплата
    if (formValues.hardSkills?.length) count++; // Навыки (массив)
    if (formValues.languages?.length) count++; // Языки (массив)

    return count;
  };

  return (
    <S.FilterBlock
      style={{ opacity: isLoading ? 0.7 : 1, pointerEvents: isLoading ? 'none' : 'initial' }}
    >
      <S.FilterBlockHeader>
        <S.FilterBlockTitle>Search Criteria</S.FilterBlockTitle>
        <S.FilterBlockDesc>
          {'Please select job post for which \n you need to find a candidate.'}
        </S.FilterBlockDesc>
        <JobPostsDropdownAutocomplete
          setValue={setJobPostsValue}
          jobPostsValue={jobPostsValue}
          getJobPostInfoById={getJobPostInfoById}
        />
      </S.FilterBlockHeader>
      <S.Separator />
      <S.FilterBlockHeader>
        <S.FilterBlockHeaderFilters>
          <S.FilterBlockTitle>
            Filters <span>({countSelectedFilters()})</span>
          </S.FilterBlockTitle>
          <S.FilterBlockClear
            onClick={() => {
              const params = new URLSearchParams(window.location.search);
              params.delete('jobPostId');
              navigate({
                pathname: window.location.pathname,
                search: `?${params.toString()}`,
              });
              setValue('query', '');
              setValue('positionType', null);
              setValue('jobLocation', null);
              setValue('onSite', false);
              setValue('remote', false);
              setValue('hybrid', false);
              setValue('yearsOfExperience', '');
              setValue('education', null);
              setValue('hardSkills', []);
              setValue('languages', []);
              setValue('salaryRange', { from: '', to: '' });
              setJobPostsValue(null);
              setPage(1);
              setTimeout(() => {
                return handleSubmit(onSubmit(1))();
              }, 0);
            }}
          >
            Clear
          </S.FilterBlockClear>
        </S.FilterBlockHeaderFilters>
        <S.FilterBlockDesc>
          {'Use filters to optimise your search \n and find a more suitable candidate'}
        </S.FilterBlockDesc>
      </S.FilterBlockHeader>
      <FiltersBlockFields
        positionTypeData={positionTypeData}
        isPositionTypeDataLoading={isPositionTypeDataLoading}
        /* jobTitleData={jobTitleData}
        isJobTitleDataLoading={isJobTitleDataLoading} */
        educationData={educationData}
        isEducationDataLoading={isEducationDataLoading}
        hardSkillsData={hardSkillsData}
        isHardSkillsLoading={isHardSkillsLoading}
        languageData={languageData}
        isLanguageDataLoading={isLanguageDataLoading}
        jobPostData={data}
        setPage={setPage}
      />
    </S.FilterBlock>
  );
};

export default FiltersBlock;
